import autoload from './autoload'
import BrandIconMarquee from './components/page_components/BrandIconMarquee.vue'
import auth from './mixins/auth'
import cart from './mixins/cart'
import initDom from './mixins/init_dom'
import diyBrandIcons from '../data/diyBrandIcons.json'

autoload()

window.app = new Vue({
  name: 'MarketingPages',
  el: '#vue-marketing-pages',
  mixins: [initDom, auth, cart],
  data() {
    return {
      brandIcons: diyBrandIcons,
    }
  },
  components: {
    BrandIconMarquee,
  },
})
